var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBase16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C9.58225 16 11.1289 15.5308 12.4445 14.6517C13.7601 13.7727 14.7856 12.5233 15.3911 11.0615C15.9966 9.59965 16.155 7.99115 15.8463 6.4393C15.5376 4.88743 14.7756 3.46197 13.6568 2.34315C12.538 1.22433 11.1126 0.462403 9.5607 0.153722C8.00885 -0.15496 6.40035 0.00346637 4.93853 0.608965C3.47672 1.21447 2.2273 2.23985 1.34825 3.55544C0.469192 4.87103 0 6.41775 0 8C0 10.1218 0.842855 12.1565 2.34314 13.6568C3.84343 15.1571 5.87825 16 8 16Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9812 13.6338C11.0927 13.6338 13.615 11.1115 13.615 8C13.615 4.88855 11.0927 2.36621 7.9812 2.36621C5.0294 2.36621 2.60781 4.63631 2.36705 7.5259H10.7272V8.46405H2.36621C2.60218 11.3585 5.02595 13.6338 7.9812 13.6338Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBase16);
export default __webpack_public_path__ + "static/media/ic_base_16.a10a0010d0a0925491654c5666b87205.svg";
export { ForwardRef as ReactComponent };